/**
 * انتقالِ کلیدهای مرورگر از `eyvan.*` به `bazivan.*` — یک بار، سرِ بالا آمدن.
 *
 * چرا اصلاً لازم است: `eyvan.device` شناسه‌ی دستگاه است. سرور با همین شناسه
 * بازیکنِ مهمان را می‌شناسد و سرِ میزِ قبلی برمی‌گرداندش. اگر با تغییرِ نام
 * فقط کلید عوض می‌شد، هر کسی که تا امروز بازی کرده بود یک آدمِ تازه می‌شد و
 * حسابِ مهمان و سکه‌هایش را گم می‌کرد — بی هیچ پیغامی.
 *
 * پیشوندی کار می‌کند و نه با فهرستِ کلیدها، تا کلیدِ تازه‌ای که فردا اضافه
 * شود هم خودبه‌خود پوشیده باشد.
 *
 * یک بار اجرا می‌شود چون ماژولِ ES فقط یک بار ارزیابی می‌شود؛ ولی خودش هم
 * بی‌خطرِ تکرار است: اگر کلیدِ تازه از قبل باشد، دست نمی‌زند.
 */
const OLD = "eyvan.";
const NEW = "bazivan.";

export function migrateStorage(store: Storage = localStorage): void {
  // اول همه را بخوان و بعد بنویس: نوشتن در میانه‌ی پیمایش، شماره‌ی کلیدها را
  // جابه‌جا می‌کند و بعضی کلیدها از قلم می‌افتند.
  const moves: Array<[string, string]> = [];
  for (let i = 0; i < store.length; i++) {
    const k = store.key(i);
    if (k && k.startsWith(OLD)) moves.push([k, NEW + k.slice(OLD.length)]);
  }
  for (const [from, to] of moves) {
    const v = store.getItem(from);
    // کلیدِ تازه اگر مقدار دارد، حرفِ آخر را می‌زند: کاربر بعدِ مهاجرت چیزی
    // عوض کرده و مقدارِ کهنه نباید رویش بنشیند.
    if (v !== null && store.getItem(to) === null) store.setItem(to, v);
    store.removeItem(from);
  }
}

try {
  migrateStorage();
} catch {
  /* حالتِ ناشناس یا ذخیره‌سازیِ بسته — بی این هم صفحه باید بالا بیاید */
}
